/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AppointmentPeriodType,
    AppointmentPeriodTypeFromJSON,
    AppointmentPeriodTypeFromJSONTyped,
    AppointmentPeriodTypeToJSON,
} from './AppointmentPeriodType';
import {
    AppointmentTypeAttachmentCreateParams,
    AppointmentTypeAttachmentCreateParamsFromJSON,
    AppointmentTypeAttachmentCreateParamsFromJSONTyped,
    AppointmentTypeAttachmentCreateParamsToJSON,
} from './AppointmentTypeAttachmentCreateParams';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    Field,
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field';
import {
    MinimumNotice,
    MinimumNoticeFromJSON,
    MinimumNoticeFromJSONTyped,
    MinimumNoticeToJSON,
} from './MinimumNotice';
import {
    ProgramEventStatus,
    ProgramEventStatusFromJSON,
    ProgramEventStatusFromJSONTyped,
    ProgramEventStatusToJSON,
} from './ProgramEventStatus';
import {
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeFromJSONTyped,
    ProgramEventTypeToJSON,
} from './ProgramEventType';
import {
    ProgramEventVenue,
    ProgramEventVenueFromJSON,
    ProgramEventVenueFromJSONTyped,
    ProgramEventVenueToJSON,
} from './ProgramEventVenue';
import {
    Rule,
    RuleFromJSON,
    RuleFromJSONTyped,
    RuleToJSON,
} from './Rule';

/**
 * 
 * @export
 * @interface AppointmentTypeUpdateParams
 */
export interface AppointmentTypeUpdateParams {
    /**
     * 
     * @type {ProgramEventType}
     * @memberof AppointmentTypeUpdateParams
     */
    type: ProgramEventType;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    online_event_url?: string;
    /**
     * 
     * @type {ProgramEventStatus}
     * @memberof AppointmentTypeUpdateParams
     */
    status: ProgramEventStatus;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    terms?: string;
    /**
     * 
     * @type {Array<Field>}
     * @memberof AppointmentTypeUpdateParams
     */
    fields: Array<Field>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentTypeUpdateParams
     */
    tags: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeUpdateParams
     */
    feedback_enabled: boolean;
    /**
     * 
     * @type {AppointmentPeriodType}
     * @memberof AppointmentTypeUpdateParams
     */
    period_type: AppointmentPeriodType;
    /**
     * How many calendar days into the future they can book
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    max_booking_time?: number;
    /**
     * Allow attendees to choose a time that is not exactly on the scheduled slot
     * @type {boolean}
     * @memberof AppointmentTypeUpdateParams
     */
    is_start_time_flexible: boolean;
    /**
     * Set the frequency of available time slots for attendees.
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    spot_step?: number;
    /**
     * Configure the max amount of registrations that are allowed per day
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    daily_events_limit?: number;
    /**
     * Invitees can't schedule within set period of event
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    min_booking_time: number;
    /**
     * 
     * @type {MinimumNotice}
     * @memberof AppointmentTypeUpdateParams
     */
    min_notice_unit: MinimumNotice;
    /**
     * Give yourself some buffer time to prepare for an appointment
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    before_buffer_time?: number;
    /**
     * Give yourself some buffer time to wrap up after an appointment
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    after_buffer_time?: number;
    /**
     * Set the limit for how frequent attendees can book appointments in the frequency period
     * @type {number}
     * @memberof AppointmentTypeUpdateParams
     */
    frequency_amount?: number;
    /**
     * Set the period for limited amount of attendee appointment bookings set
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    frequency_period?: string;
    /**
     * Defines the date that attendees can start scheduling appointments from.
     * @type {Date}
     * @memberof AppointmentTypeUpdateParams
     */
    starts_at?: Date;
    /**
     * Defines the date that attendees can schedule appointments up to.
     * @type {Date}
     * @memberof AppointmentTypeUpdateParams
     */
    ends_at?: Date;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof AppointmentTypeUpdateParams
     */
    rules: Array<Rule>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeUpdateParams
     */
    is_online_event: boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof AppointmentTypeUpdateParams
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    program_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentTypeUpdateParams
     */
    restrict_to_package_ids?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentTypeUpdateParams
     */
    is_preregistration_enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    picture_file_id?: string;
    /**
     * 
     * @type {Array<AppointmentTypeAttachmentCreateParams>}
     * @memberof AppointmentTypeUpdateParams
     */
    attachments?: Array<AppointmentTypeAttachmentCreateParams>;
    /**
     * 
     * @type {Array<ProgramEventVenue>}
     * @memberof AppointmentTypeUpdateParams
     */
    venues?: Array<ProgramEventVenue>;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTypeUpdateParams
     */
    id: string;
}

export function AppointmentTypeUpdateParamsFromJSON(json: any): AppointmentTypeUpdateParams {
    return AppointmentTypeUpdateParamsFromJSONTyped(json, false);
}

export function AppointmentTypeUpdateParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeUpdateParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': ProgramEventTypeFromJSON(json['type']),
        'name': json['name'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'online_event_url': !exists(json, 'online_event_url') ? undefined : json['online_event_url'],
        'status': ProgramEventStatusFromJSON(json['status']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'terms': !exists(json, 'terms') ? undefined : json['terms'],
        'fields': ((json['fields'] as Array<any>).map(FieldFromJSON)),
        'tags': json['tags'],
        'feedback_enabled': json['feedback_enabled'],
        'period_type': AppointmentPeriodTypeFromJSON(json['period_type']),
        'max_booking_time': !exists(json, 'max_booking_time') ? undefined : json['max_booking_time'],
        'is_start_time_flexible': json['is_start_time_flexible'],
        'spot_step': !exists(json, 'spot_step') ? undefined : json['spot_step'],
        'daily_events_limit': !exists(json, 'daily_events_limit') ? undefined : json['daily_events_limit'],
        'min_booking_time': json['min_booking_time'],
        'min_notice_unit': MinimumNoticeFromJSON(json['min_notice_unit']),
        'before_buffer_time': !exists(json, 'before_buffer_time') ? undefined : json['before_buffer_time'],
        'after_buffer_time': !exists(json, 'after_buffer_time') ? undefined : json['after_buffer_time'],
        'frequency_amount': !exists(json, 'frequency_amount') ? undefined : json['frequency_amount'],
        'frequency_period': !exists(json, 'frequency_period') ? undefined : json['frequency_period'],
        'starts_at': !exists(json, 'starts_at') ? undefined : (new Date(json['starts_at'])),
        'ends_at': !exists(json, 'ends_at') ? undefined : (new Date(json['ends_at'])),
        'rules': ((json['rules'] as Array<any>).map(RuleFromJSON)),
        'is_online_event': json['is_online_event'],
        'currency': CurrencyCodeFromJSON(json['currency']),
        'timezone': json['timezone'],
        'program_id': json['program_id'],
        'restrict_to_package_ids': !exists(json, 'restrict_to_package_ids') ? undefined : json['restrict_to_package_ids'],
        'is_preregistration_enabled': !exists(json, 'is_preregistration_enabled') ? undefined : json['is_preregistration_enabled'],
        'picture_file_id': !exists(json, 'picture_file_id') ? undefined : json['picture_file_id'],
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(AppointmentTypeAttachmentCreateParamsFromJSON)),
        'venues': !exists(json, 'venues') ? undefined : ((json['venues'] as Array<any>).map(ProgramEventVenueFromJSON)),
        'id': json['id'],
    };
}

export function AppointmentTypeUpdateParamsToJSON(value?: AppointmentTypeUpdateParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': ProgramEventTypeToJSON(value.type),
        'name': value.name,
        'summary': value.summary,
        'description': value.description,
        'online_event_url': value.online_event_url,
        'status': ProgramEventStatusToJSON(value.status),
        'url': value.url,
        'terms': value.terms,
        'fields': ((value.fields as Array<any>).map(FieldToJSON)),
        'tags': value.tags,
        'feedback_enabled': value.feedback_enabled,
        'period_type': AppointmentPeriodTypeToJSON(value.period_type),
        'max_booking_time': value.max_booking_time,
        'is_start_time_flexible': value.is_start_time_flexible,
        'spot_step': value.spot_step,
        'daily_events_limit': value.daily_events_limit,
        'min_booking_time': value.min_booking_time,
        'min_notice_unit': MinimumNoticeToJSON(value.min_notice_unit),
        'before_buffer_time': value.before_buffer_time,
        'after_buffer_time': value.after_buffer_time,
        'frequency_amount': value.frequency_amount,
        'frequency_period': value.frequency_period,
        'starts_at': value.starts_at === undefined ? undefined : (value.starts_at.toISOString()),
        'ends_at': value.ends_at === undefined ? undefined : (value.ends_at.toISOString()),
        'rules': ((value.rules as Array<any>).map(RuleToJSON)),
        'is_online_event': value.is_online_event,
        'currency': CurrencyCodeToJSON(value.currency),
        'timezone': value.timezone,
        'program_id': value.program_id,
        'restrict_to_package_ids': value.restrict_to_package_ids,
        'is_preregistration_enabled': value.is_preregistration_enabled,
        'picture_file_id': value.picture_file_id,
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(AppointmentTypeAttachmentCreateParamsToJSON)),
        'venues': value.venues === undefined ? undefined : ((value.venues as Array<any>).map(ProgramEventVenueToJSON)),
        'id': value.id,
    };
}

